import EditableTable from "./EditableTable";
import { AnyObject } from "../../../models";

type EditableTableComponent = typeof EditableTable;
const Component = EditableTable as AnyObject;

export default Component as EditableTableComponent;
export type { EditableTableColumn } from "./EditableTable";
export { default as EditableTableCell } from "./EditableTableCell";
export type { EditableCellType } from "./EditableTableCell";
export {
  EditingContext,
  useEditingContext,
  CellPositionContext,
  useCellPosition,
  makeCellKey,
} from "./EditableTableContext";
export type {
  EditingCell,
  EditingContextValue,
  CellKey,
  CellRegistration,
} from "./EditableTableContext";
export { coerceValueForPaste, formatValueForCopy } from "./coerceValueForPaste";
